module.exports = __webpack_public_path__ + "static/weaving_tides-589fe967eb198d35d3eaff33d4bc1e6e.png";